module.exports = __webpack_public_path__ + "static/media/Gambit.770bd4ba.jpg";